[
  {
    "growth":-3.5,
    "skill":"JavaScript",
    "display_name":"JavaScript",
    "part":9.1
  },
  {
    "growth":-3.3,
    "skill":"WordPress",
    "display_name":"WordPress",
    "part":7.3
  },
  {
    "growth":-0.9,
    "skill":"Python",
    "display_name":"Python",
    "part":6.3
  },
  {
    "growth":-1.0,
    "skill":"React.js",
    "display_name":"React.js",
    "part":5.0
  },
  {
    "growth":-2.4,
    "skill":"PHP",
    "display_name":"PHP",
    "part":4.8
  },
  {
    "growth":-1.4,
    "skill":"Node.js",
    "display_name":"Node.js",
    "part":4.4
  },
  {
    "growth":-1.4,
    "skill":"Java",
    "display_name":"Java",
    "part":3.9
  },
  {
    "growth":-0.8,
    "skill":"Docker",
    "display_name":"Docker",
    "part":3.5
  },
  {
    "growth":-0.4,
    "skill":"TypeScript",
    "display_name":"TypeScript",
    "part":2.9
  },
  {
    "growth":-0.6,
    "skill":"PostgreSQL",
    "display_name":"PostgreSQL",
    "part":2.7
  }
]
